import { Navigate } from "react-router-dom";
import { Flex, Spin, Typography } from "antd";
import { useAuth } from "../lib/auth";
import type { ReactElement } from "react";

export default function ProtectedRoute({ children }: { children: ReactElement }) {
  const { user, loading, allowlisted } = useAuth();

  if (loading) {
    return (
      <Flex align="center" justify="center" style={{ minHeight: "60vh" }}>
        <Spin tip={<Typography.Text>Loading secure workspace...</Typography.Text>} />
      </Flex>
    );
  }

  if (!user) {
    return <Navigate to="/signin" replace />;
  }

  if (!allowlisted) {
    return <Navigate to="/request-access" replace />;
  }

  return children;
}
